// extracted by mini-css-extract-plugin
export default {"title":"CurrentInsurance_title__f3QrK","description":"CurrentInsurance_description__V+S85","link":"CurrentInsurance_link__XYwV7"};